import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-candidate-address',
  templateUrl: './candidate-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateAddressComponent {
  @Input() address: string;
}
